export class Client {
  id?: number;
  number: number;
  companyName?: string;
  observations?: string;
  documentNumber?: string;
  address?: string;
  email?: string;
  phone?: string;
  cellphone?: string;
  locality?: string;
  province?: string;
  country?: string;
  state?: string;
  city?: string;
  postalCode?: string;
  type: string;
  documentTypeId?: number;
  responsibleTypeId?: number;
  bonificacionValue?: number;
  latitude?: number;
  longitude?: number;
}
